export default {
  "removeItem": "Rimuovi l'articolo",
  "addItem": "Aggiungi l'articolo",
  "invalidClubCodeForInRoomScreenRoute": "Codice del club non valido per la via dello schermo in camera",
  "screenNotProvisionedMissingClubCodeDeviceCode": "Schermo non fornito / club mancanteCode / dispositivoCode",
  "screenNotFound": "Schermo non trovato",
  "unableToStartProvisioning": "Incapace di avviare il provisioning",
  "waitingForProvisioning": "In attesa di provvista...",
  "memberMode": "Modalità d'iscrizione",
  "yourPrivateSanctuary": "Il tuo santuario privato",
  "communication": "Comunicazione",
  "bookings": "Prenotazioni",
  "diningDrinks": "Ristorazione e bevande",
  "activities": "Attività",
  "roomService": "Servizio in camera",
  "message": "Messaggio",
  "contactConciergeStaff": "Contattare il personale e il concierge",
  "reservations": "Prenotazioni",
  "viewAndAdjustUpcomingBookings": "Visualizzare e regolare le prenotazioni in arrivo",
  "orderDrinks": "Ordina bevande",
  "seeOurMenus": "Guarda i nostri menu",
  "planActivities": "Pianifica attività",
  "exploreOurAmenities": "Scopri i nostri servizi",
  "callFrontDesk": "Chiama la reception",
  "golfTeeTimes": "Orari di partenza golf",
  "spaRitual": "rituale di spa",
  "fitnessSession": "Sessione di fitness",
  "racquetCourt": "Corte di racchetta",
  "dining": "Ceneri",
  "signatureCocktails": "Cocktail di firma",
  "wineList": "Lista dei vini",
  "inRoomDining": "Sala da pranzo",
  "eventsCalendar": "Calendario eventi",
  "guidedTours": "Visite guidate",
  "wellnessSchedule": "Programma benessere",
  "localHighlights": "Punti salienti locali",
  "breakfast": "Prima colazione",
  "lateNightBites": "Morsi di notte tardi",
  "housekeepingRequest": "Richiesta di pulizia",
  "welcomeBack": "Bentornato.",
  "welcome": "Benvenuto",
  "messageFrontDesk": "Messaggio reception",
  "missingClub": "Club mancante",
  "unableToPlaceTheCall": "Incapace di piazzare la chiamata.",
  "roomUnavailable": "Camera non disponibile",
  "noRoomIsAssignedToThisScreen": "Nessuna stanza è assegnata a questa schermata.",
  "frontDeskCallingIsntConfiguredYet": "La chiamata della reception non è ancora configurata.",
  "unableToPlaceCall": "Incapace di piazzare la chiamata",
  "pleaseTryAgainSoon": "Vi prego di riprovare presto.",
  "callingFrontDesk": "Chiamare la reception...",
  "connectingYourRequest": "Collegare la vostra richiesta.",
  "unableToHangUp": "Non riesco a riattaccare",
  "pleaseTryAgain": "Riprova.",
  "messageFailed": "Messaggio fallito",
  "item": "Articolo",
  "orderPlaced": "Ordine posto · #",
  "roomServiceHasReceivedYourRequest": "Il servizio in camera ha ricevuto la vostra richiesta.",
  "pleaseReviewYourOrderAndTryAgain": "Si prega di rivedere il vostro ordine e riprovare.",
  "menuIsNoLongerAvailable": "Il menu non è più disponibile.",
  "orderRetryConflictPleaseTryAgain": "Ordine di retry conflitto. Per favore riprovare.",
  "unableToPlaceOrder": "In grado di effettuare l'ordine",
  "pleaseTryAgainInAMoment": "Si prega di riprovare in un momento.",
  "room": "Camera",
  "deviceDisabled": "Dispositivo disattivato",
  "thisScreenIsDisabledAskStaffToEnableItInTheClubPortal": "Questa schermata è disattivata. Chiedi al personale di abilitarlo nel portale del club.",
  "screenAlreadyPaired": "Schermo già abbinato",
  "thisScreenIsAlreadyPairedToClub": "Questo schermo è già abbinato al club",
  "device": ", dispositivo",
  "openInRoomScreen": "Schermo aperto in camera",
  "pairAnotherScreen": "Coprire un altro schermo",
  "screenProvisioning": "Provisione dello schermo",
  "installID": "Installare ID:",
  "shareThisCodeWithClubStaffToClaimThisScreen": "Condividi questo codice con il personale del club per rivendicare questa schermata.",
  "expiresIn": "Scadenze in",
  "staffInstructions": "Istruzioni per il personale",
  "openTheClubPortalRoomsInRoomScreens": "Aprire il portale del club > Camere > Schermi in camera.",
  "clickAddScreenAndEnterThisCode": "Fare clic su \"Aggiungi schermo\" e inserire questo codice.",
  "selectTheRoomToAssignAndSubmit": "Selezionare la stanza per assegnare e inviare.",
  "status": "Stato:",
  "waitingForAClubAdminToClaimThisScreenTheDisplayWillAutomaticallyContinueOnceAssigned": "In attesa di un amministratore del club di rivendicare questa schermata. Il display continuerà automaticamente una volta assegnato.",
  "suiteBackdrop": "Sfondo suite",
  "privacy": "Privacy",
  "home": "Casa",
  "wellNotifyYouWhenItsReady": "Ti avviseremo quando sara' pronto.",
  "memberPortal": "Portale dei soci",
  "bookingsMessagingAndSchedulesStayAvailable": "Prenotazioni, messaggistica e orari di soggiorno disponibili.",
  "backToHome": "Torna alla pagina iniziale",
  "signOutOnThisScreen": "Iscriviti su questa schermata",
  "memberPortalModulesRenderHereInProductionThisPlaceholderKeepsTheLayoutConsistentWhileThePairingSessionIsActive": "I moduli del portale dei soci sono qui in produzione. Questo segnaposto mantiene il layout coerente mentre la sessione di accoppiamento è attiva.",
  "bookingShortcuts": "Scorciatoie di prenotazione",
  "messagesConcierge": "Messaggi e concierge",
  "liveChatWithTheFrontDeskTeam": "Live chat con il team della reception.",
  "back": "Indietro",
  "typeYourMessage": "Digitare il messaggio...",
  "send": "Invia",
  "refinedOptionsCuratedForYourStay": "Opzioni raffinate curate per il vostro soggiorno.",
  "inCallWithFrontDesk": "In chiamata con reception",
  "callEnded": "Chiamata terminata",
  "tapToContinue": "Toccare per continuare",
  "enter": "Inserisci",
  "hangUp": "Tieni duro.",
  "confirmRoomServiceOrder": "Confermare l'ordine del servizio in camera",
  "reviewYourItemsBeforePlacingTheOrder": "Esamina i tuoi articoli prima di effettuare l'ordine.",
  "subtotal": "Subtotale",
  "deliveryFee": "Tassa di consegna",
  "total": "Totale",
  "cancel": "Annulla",
  "placingOrder": "Ordine di posizionamento...",
  "confirmOrder": "Confermare l'ordine",
  "pairDevice": "Dispositivo di coppia",
  "syncWithYourPhone": "Sincronizza con il tuo telefono",
  "pairingCode": "Codice di accoppiamento",
  "menus": "Menù",
  "loadingMenus": "Caricamento dei menu...",
  "noRoomServiceMenusAvailable": "Non sono disponibili menu di servizio in camera.",
  "items": "Articoli",
  "loadingItems": "Caricamento articoli...",
  "basket": "Cesto",
  "noItemsYet": "Non ci sono ancora articoli.",
  "placeOrder": "Ordine del posto",
  "loading": "Caricamento...",
  "requested": "richiesto",
  "confirmed": "confermato",
  "preparing": "preparazione",
  "ready": "pronto",
  "delivered": "consegnati",
  "cancelled": "annullata"
};
